import { MvnMessage } from "@newLibs/utils";
import { DOCS_DOCUMENT_LANG } from "@maven-msg/lang/docs";
import { DocumentSignerAttrType } from "@maven-rest/docs/DocumentSign.dto";

export enum ECONSENT_DATE_FORMAT {
  YYYYMMDD_Hyphen = "YYYY-MM-DD",
  YYYYMMDD_Slash = "YYYY/MM/DD",
}

export const readableDocumentSignerAttrType = (type: DocumentSignerAttrType) => {
  switch (type) {
    case DocumentSignerAttrType.Name:
      return MvnMessage(DOCS_DOCUMENT_LANG.DOCUMENT_SIGN_NAME);
    case DocumentSignerAttrType.Signature:
      return MvnMessage(DOCS_DOCUMENT_LANG.DOCUMENT_SIGN_SIGNATURE);
    case DocumentSignerAttrType.Date:
      return MvnMessage(DOCS_DOCUMENT_LANG.DOCUMENT_SIGN_DATE);
    default:
      return "";
  }
};
